import React, { useEffect, useState } from "react";
import { FormControl, Select, MenuItem, Checkbox, ListItemText } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../axios-order";
import { useHistory } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import SelectField from "../../../components/ui/basicSelectInput";
import excelIconImage from '../../../asserts/images/excelicon.svg';

const C = {
    navy: "#1a3f6f",
    accent: "#1a6fc4",
    accentLight: "#e8f1fb",
    white: "#ffffff",
    surface: "#f7f9fc",
    border: "#dde3ec",
    borderLight: "#eef1f6",
    text: "#1a3f6f",
    textSub: "#4a6080",
    textMuted: "#8298b2",
    success: { bg: "#edf8f1", text: "#1a6e3e", dot: "#28a55f" },
    fail: { bg: "#fdecea", text: "#b71c1c", dot: "#e53935" },
};

const monthArray = [
    { id: 4, value: "April" },
    { id: 5, value: "May" },
    { id: 6, value: "June" },
    { id: 7, value: "July" },
    { id: 8, value: "August" },
    { id: 9, value: "September" },
    { id: 10, value: "October" },
    { id: 11, value: "November" },
    { id: 12, value: "December" },
    { id: 1, value: "January" },
    { id: 2, value: "February" },
    { id: 3, value: "March" },
];

const comparisonTypeOptions = [
    { id: 0, type: "GSTR1 vs Books" },
    { id: 1, type: "GSTR3B vs Books" },
    { id: 5, type: "GSTR3B vs GSTR1" },
];

const DocIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={C.accent} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="9" y1="13" x2="15" y2="13" />
        <line x1="9" y1="17" x2="13" y2="17" />
    </svg>
);

export default function SectionReport() {
    let history = useHistory();
    const [newReconFormOpen, setNewReconFormOpen] = useState(false);
    const [newReconHistoryTable, setNewReconHistoryTable] = useState([]);
    const [yearFromArr, setFromYearArr] = useState([]);
    const [loaderForTable, setLoaderForTable] = useState(true);
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedFromMonth, setSelectedFromMonth] = useState("");
    const [selectedToMonth, setSelectedToMonth] = useState("");
    const [selectedComparisonType, setSelectedComparisonType] = useState([]);
    const [filteredToMonths, setFilteredToMonths] = useState(monthArray);
    const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);
    const [activeFilter, setActiveFilter] = useState("all");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

    const thStyle = { padding: "11px 18px", textAlign: "left", fontSize: "11px", fontWeight: "600", letterSpacing: "0.05em", color: "#ffffff", background: C.navy, borderBottom: "1px solid #16355c", textTransform: "uppercase", whiteSpace: "nowrap" };
    const tdStyle = { padding: "8px 18px", fontSize: "13px", color: C.text, borderBottom: `1px solid ${C.borderLight}` };

    const handleCloseSnackbar = () => setSnackbar({ open: false, message: "", severity: "info" });
    const handleComparisonTypeChange = (e) => setSelectedComparisonType(e.target.value);
    const handleYearChange = (e) => setSelectedYear(e.target.value);

    const handleFromMonthChange = (e) => {
        const selectedFrom = e.target.value;
        setSelectedFromMonth(selectedFrom);
        const fromMonthIndex = monthArray.findIndex(m => m.value === selectedFrom);
        setFilteredToMonths(monthArray.slice(fromMonthIndex));
    };

    const handleToMonthChange = (e) => setSelectedToMonth(e.target.value);

    const getReportDetails = () => {
        setLoaderForTable(true);
        axios
            .get(`/arc/log_details/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                setLoaderForTable(false);
                setNewReconHistoryTable(res.data.records);
                setFromYearValues(res.data.financial_years);
            })
            .catch(() => setLoaderForTable(false));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmitAttempted(true);
        if (selectedComparisonType.length === 0) {
            setSnackbar({ open: true, message: "Please select at least one comparison type", severity: "error" });
            return;
        }
        const payloadData = {
            financial_year: selectedYear,
            from_month: selectedFromMonth,
            to_month: selectedToMonth,
            comparison_type: selectedComparisonType,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };
        axios
            .post("/arc/gstr1_vs_3b_summary", payloadData)
            .then((res) => {
                setSnackbar({ open: true, message: res.data.message, severity: res.data.status ? "success" : "error" });
                if (res.data.status) getReportDetails();
            })
            .catch((err) => {
                setSnackbar({ open: true, message: err.response?.data?.message || "An error occurred", severity: "error" });
            });
        newReconFormModalClose();
    };

    useEffect(() => { getReportDetails(); setFromYearValues(); }, []);

    const newReconFormModalOpen = () => {
        setNewReconFormOpen(true);
        setSelectedYear("");
        setSelectedFromMonth("");
        setSelectedToMonth("");
        setSelectedComparisonType([]);
        setIsSubmitAttempted(false);
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const genarateExcel = (item) => {
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `${item.comparison_type2}.xlsx`;
        axios
            .get(`/arc/generate_excel_report/${item.id}`)
            .then((res) => downloadBase64File(contentType, res.data.file, filename))
            .catch(() => { });
    };

    const newReconFormModalClose = () => {
        setNewReconFormOpen(false);
    };

    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 10; i <= current_year; i++) {
            const toYear = String(i + 1);
            yearArr.push({ id: i, year: `${i}-${toYear.slice(2)}` });
        }
        setFromYearArr(yearArr);
    };

    // counts
    const totalCount = newReconHistoryTable ? newReconHistoryTable.length : 0;
    const passCount = newReconHistoryTable ? newReconHistoryTable.filter(r => r.comparison_status === "Pass").length : 0;
    const failCount = newReconHistoryTable ? newReconHistoryTable.filter(r => r.comparison_status !== "Pass").length : 0;

    // filtered data
    const filteredTableData = newReconHistoryTable ? newReconHistoryTable.filter((item) =>
        activeFilter === "all" ||
        (activeFilter === "pass" && item.comparison_status === "Pass") ||
        (activeFilter === "fail" && item.comparison_status !== "Pass")
    ) : [];

    const renderTableBody = () => {
        if (loaderForTable) {
            return Array.from({ length: 3 }).map((_, i) => (
                <tr key={i}>
                    {[40, 20, 20, 40, 50, 20, 10].map((w, j) => (
                        <td key={j} style={tdStyle}>
                            <div style={{ height: "14px", borderRadius: "4px", background: C.borderLight, width: `${w}%`, animation: "pulse 1.4s ease-in-out infinite" }} />
                        </td>
                    ))}
                </tr>
            ));
        }
        if (!filteredTableData || filteredTableData.length === 0) {
            return (
                <tr>
                    <td colSpan={7} style={{ ...tdStyle, textAlign: "center", padding: "52px 20px" }}>
                        <div style={{ fontSize: "28px", marginBottom: "10px", opacity: 0.4 }}>📄</div>
                        <div style={{ fontWeight: "500", marginBottom: "4px", color: C.textSub }}>No reports found</div>
                        <div style={{ fontSize: "12px", color: C.textMuted }}>Generate your first comparison report to get started.</div>
                    </td>
                </tr>
            );
        }
        return filteredTableData.map((item, i) => {
            const isPass = item.comparison_status === "Pass";
            return (
                <tr
                    key={i}
                    onMouseEnter={() => setHoveredRow(i)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{ background: hoveredRow === i ? C.surface : C.white, transition: "background 0.1s" }}
                >
                    <td style={tdStyle}><span style={{ fontWeight: "600" }}>{item.financial_year}</span></td>
                    <td style={tdStyle}>{item.from_month}</td>
                    <td style={tdStyle}>{item.to_month}</td>
                    <td style={{ ...tdStyle, fontSize: "12px", color: C.textMuted }}>{item.run_date_time}</td>
                    <td style={tdStyle}>{item.comparison_type2}</td>
                    <td style={tdStyle}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", padding: "3px 10px", borderRadius: "5px", fontSize: "11px", fontWeight: "600", background: isPass ? C.success.bg : C.fail.bg, color: isPass ? C.success.text : C.fail.text }}>
                            <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: isPass ? C.success.dot : C.fail.dot, flexShrink: 0 }} />
                            {item.comparison_status}
                        </span>
                    </td>
                    <td style={{ ...tdStyle, textAlign: "center" }}>
                        <img
                            onClick={() => isPass && genarateExcel(item)}
                            style={{ height: "23px", width: "25px", cursor: isPass ? "pointer" : "not-allowed", opacity: isPass ? 1 : 0.4 }}
                            src={excelIconImage}
                            alt="excel"
                        />
                    </td>
                </tr>
            );
        });
    };

    return (
        <>
            <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }`}</style>

            <div style={{ padding: "28px 32px", background: C.surface, fontFamily: "inherit" }}>

                {/* Page header */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", marginBottom: "20px", boxShadow: "0 1px 3px rgba(13,33,55,0.06)" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                        <button
                            onClick={() => history.push("/reportCards")}
                            title="Back to Reports"
                            style={{ width: "32px", height: "32px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: C.textSub, fontSize: "14px", flexShrink: 0 }}
                        >←</button>
                        <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: C.accentLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <DocIcon />
                        </div>
                        <div>
                            <div style={{ fontSize: "23px", fontWeight: "700", color: C.text, lineHeight: 1.2 }}>Section Wise Comparison</div>
                            <div style={{ fontSize: "12px", color: C.textMuted, marginTop: "4px" }}>Outward supply comparison records</div>
                        </div>
                    </div>
                    <button
                        onClick={newReconFormModalOpen}
                        style={{ display: "flex", alignItems: "center", gap: "6px", padding: "0 18px", height: "36px", borderRadius: "8px", background: C.navy, color: C.white, border: "none", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}
                    >
                        <span style={{ fontSize: "16px", lineHeight: 1 }}>+</span>
                        New Section Wise Comparison Report
                    </button>
                </div>

                {/* Metrics
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "20px" }}>
                    {[
                        // { label: "Total Reports", value: totalCount, borderColor: C.accent, badge: totalCount > 0 },
                        // { label: "Pass", value: passCount, borderColor: "#28a55f", badge: false },
                        // { label: "Fail", value: failCount, borderColor: "#e53935", badge: false },
                    ].map(({ label, value, borderColor, badge }) => (
                        <div key={label} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", padding: "16px 20px", boxShadow: "0 1px 3px rgba(13,33,55,0.05)", borderTop: `3px solid ${borderColor}` }}>
                            <div style={{ fontSize: "26px", fontWeight: "700", color: C.text, lineHeight: 1, letterSpacing: "-0.5px" }}>{value}</div>
                            <div style={{ fontSize: "11px", color: C.textMuted, marginTop: "5px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.06em" }}>{label}</div>
                            {badge && <div style={{ display: "inline-block", marginTop: "8px", fontSize: "10px", padding: "2px 8px", borderRadius: "12px", background: C.success.bg, color: C.success.text, fontWeight: "600" }}>All generated</div>}
                        </div>
                    ))}
                </div> */}

                {/* Table card */}
                <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: "10px", overflow: "hidden", boxShadow: "0 1px 3px rgba(13,33,55,0.05)" }}>

                    {/* Toolbar */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: `1px solid ${C.border}`, background: C.white }}>
                        <div style={{ display: "flex", gap: "4px" }}>
                            {[
                                // { key: "all",  label: `All (${totalCount})` },
                                // { key: "pass", label: `Pass (${passCount})` },
                                // { key: "fail", label: `Fail (${failCount})` },
                            ].map(({ key, label }) => {
                                const active = activeFilter === key;
                                return (
                                    <button
                                        key={key}
                                        onClick={() => setActiveFilter(key)}
                                        style={{ padding: "5px 14px", borderRadius: "6px", border: `1px solid ${active ? C.navy : C.border}`, background: active ? C.navy : C.white, color: active ? C.white : C.textSub, fontSize: "12px", fontWeight: active ? "600" : "400", cursor: "pointer", transition: "all 0.15s" }}
                                    >
                                        {label}
                                    </button>
                                );
                            })}
                        </div>
                        <button
                            onClick={getReportDetails}
                            style={{ padding: "5px 14px", borderRadius: "6px", border: `1px solid ${C.border}`, background: C.white, color: C.textSub, fontSize: "12px", fontWeight: "400", cursor: "pointer", transition: "all 0.15s" }}
                        >
                            ↻ Refresh
                        </button>
                    </div>

                    {/* Scrollable table area */}
                    <div style={{ maxHeight: "480px", overflowY: "auto", overflowX: "hidden" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                            <colgroup>
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "20%" }} />
                                <col style={{ width: "24%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "8%" }} />
                            </colgroup>
                            <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr>
                                    <th style={thStyle}>Fiscal Year</th>
                                    <th style={thStyle}>From Month</th>
                                    <th style={thStyle}>To Month</th>
                                    <th style={thStyle}>Created Date</th>
                                    <th style={thStyle}>Comparison Type</th>
                                    <th style={thStyle}>Status</th>
                                    <th style={{ ...thStyle, textAlign: "center" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableBody()}</tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    {!loaderForTable && filteredTableData.length > 0 && (
                        <div style={{ padding: "10px 18px", borderTop: `1px solid ${C.borderLight}`, fontSize: "11px", color: C.textMuted, background: C.white }}>
                            Showing {filteredTableData.length} of {totalCount} records
                        </div>
                    )}

                </div>{/* end Table card */}

            </div>{/* end page wrapper */}

            {/* Modal */}
            <Modal size="lg" centered show={newReconFormOpen} onHide={newReconFormModalClose}>
                <Modal.Header closeButton style={{ background: C.navy, borderBottom: "none", padding: "16px 22px" }}>
                    <Modal.Title style={{ fontSize: "18px", fontWeight: "600", color: "#ffffff" }}>
                        Section Wise Comparison
                    </Modal.Title>
                </Modal.Header>

                <ValidatorForm onSubmit={handleSubmit} onError={() => setIsSubmitAttempted(true)}>
                    <Modal.Body style={{ padding: "22px 22px 10px" }}>

                        <div style={{ marginBottom: "18px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Financial Year <span style={{ color: "#e53e3e" }}>*</span>
                            </label>
                            <SelectField
                                validator={["required"]}
                                errorMsg={["This field is required"]}
                                choice_id="year"
                                choice_name="year"
                                name="year"
                                choices={yearFromArr}
                                value={selectedYear}
                                onChange={handleYearChange}
                            />
                        </div>

                        <div style={{ marginBottom: "18px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Period <span style={{ color: "#e53e3e" }}>*</span>
                            </label>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                <div>
                                    <div style={{ fontSize: "11px", color: C.textMuted, marginBottom: "5px" }}>From month</div>
                                    <SelectField
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                        choice_id="value"
                                        choice_name="value"
                                        name="from_month"
                                        value={selectedFromMonth}
                                        onChange={handleFromMonthChange}
                                        choices={monthArray}
                                    />
                                </div>
                                <div>
                                    <div style={{ fontSize: "11px", color: C.textMuted, marginBottom: "5px" }}>To month</div>
                                    <SelectField
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                        choice_id="value"
                                        choice_name="value"
                                        name="to_month"
                                        value={selectedToMonth}
                                        textOnchangeFunction={(e) => setSelectedToMonth(e.target.value)}
                                        choices={filteredToMonths}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ marginBottom: "18px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: C.textSub, marginBottom: "6px", display: "block", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Comparison Type <span style={{ color: "#e53e3e" }}>*</span>
                            </label>
                            <FormControl fullWidth variant="outlined" error={isSubmitAttempted && selectedComparisonType.length === 0}>
                                <Select
                                    multiple
                                    name="selectedComparisonType"
                                    value={selectedComparisonType}
                                    onChange={handleComparisonTypeChange}
                                    renderValue={(selected) => selected.length === 0 ? "" : selected.join(", ")}
                                    displayEmpty
                                    MenuProps={{ PaperProps: { style: { maxHeight: 250 } }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, getContentAnchorEl: null }}
                                    style={{ height: "36px", fontSize: "14px", backgroundColor: "white" }}
                                >
                                    {comparisonTypeOptions.map((option) => (
                                        <MenuItem key={option.id} value={option.type}>
                                            <Checkbox checked={selectedComparisonType.indexOf(option.type) > -1} style={{ padding: "4px" }} />
                                            <ListItemText primary={option.type} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                {isSubmitAttempted && selectedComparisonType.length === 0 && (
                                    <p style={{ color: "#f44336", fontSize: "12px", marginTop: "3px", marginLeft: "14px", marginBottom: "0px" }}>
                                        This field is required
                                    </p>
                                )}
                            </FormControl>
                        </div>

                    </Modal.Body>

                    <Modal.Footer style={{ padding: "12px 22px", gap: "8px", borderTop: `1px solid ${C.borderLight}` }}>
                        <button type="button" onClick={newReconFormModalClose} style={{ padding: "0 18px", height: "36px", borderRadius: "8px", border: `1px solid ${C.border}`, background: C.white, fontSize: "13px", color: C.textSub, cursor: "pointer" }}>
                            Cancel
                        </button>
                        <button type="submit" style={{ padding: "0 22px", height: "36px", borderRadius: "8px", background: C.navy, color: C.white, border: "none", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                            Generate Report
                        </button>
                    </Modal.Footer>
                </ValidatorForm>
            </Modal>

            {/* Snackbar */}
            <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}